module.exports = __webpack_public_path__ + "img/concrete-hole-decal-17.a9d4771e.png";